export default __webpack_public_path__ + "static/media/825.157fac01.png";